module.exports = __webpack_public_path__ + "ca79b9696f1cd0d07f486e1c4336283e.svg";